// extracted by mini-css-extract-plugin
module.exports = {"content":"footer_content__1aslN"};
    if(module.hot) {
      // 1783591913494
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  